import { mutatorAction } from 'satcheljs';
import {
    MailboxInfo,
    getUserMailboxId,
    MailboxType,
    getUserMailboxInfo,
    getDefaultRoutingKey,
    getRoutingKeyPrefixForSmtpAddress,
} from 'owa-client-ids';
import { getFolderTable, SHARED_FOLDERS_TREE_TYPE, getDefaultRequestOptions } from 'owa-folders';
import getStore from '../store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Utility which returns user mailbox info as per folder id
 * @param folderId
 */
export default function fetchUserMailboxInfoFromFolderId(folderId: string): MailboxInfo {
    // Return request options as default mailbox info if folderId is not present
    if (!folderId) {
        return getUserMailboxInfo();
    }

    // Save recomputation by storing the request options in a map per folder
    if (!getStore().has(folderId)) {
        let mailboxInfo = GetUserMailboxInfoUsingFolderId(folderId);
        addToStore(folderId, mailboxInfo);
    }

    return getStore().get(folderId);
}

/**
 * Fetches user mailbox id for a given folder id
 * @param folderId
 */
function GetUserMailboxInfoUsingFolderId(folderId: string): MailboxInfo {
    const folderTable = getFolderTable();
    const folder = folderTable && folderTable.get(folderId);

    let mailboxId: string;
    let primarySmtpAddress: string;
    let routingKey: string;

    if (folder && folder.treeType === SHARED_FOLDERS_TREE_TYPE) {
        mailboxId = folder.principalSMTPAddress;
        primarySmtpAddress = folder.principalSMTPAddress;
        routingKey = getRoutingKeyPrefixForSmtpAddress() + folder.principalSMTPAddress;
    } else {
        mailboxId = getUserMailboxId();
        primarySmtpAddress = getUserConfiguration().SessionSettings.UserEmailAddress;
        routingKey = getDefaultRoutingKey();
    }

    return {
        type: MailboxType.UserMailbox,
        deprecatedMailboxId: mailboxId,
        primarySmtpAddress: primarySmtpAddress,
        routingKey: routingKey,
        returnModernConversationItems: false,
        requestOptions: getDefaultRequestOptions(folderId),
    };
}

const addToStore = mutatorAction(
    'addMailboxInfoToStore',
    (folderId: string, mailboxInfo: MailboxInfo) => {
        getStore().set(folderId, mailboxInfo);
    }
);
